import { render } from "./LogoIcon.vue?vue&type=template&id=3f58e408"
import script from "./LogoIcon.vue?vue&type=script&lang=js"
export * from "./LogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__